import React, { useState, useEffect } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444',PURPLE='#7C3AED';
const s = {
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
};

const DOC_TYPES = [
  {key:'talon', label:'Talon / Certificat înmatriculare', icon:'📋', ocr:true},
  {key:'ci_proprietar', label:'CI Proprietar', icon:'🪪', ocr:true},
  {key:'civ', label:'CIV — Carte identitate vehicul', icon:'📘', ocr:false},
  {key:'polita_rca', label:'Poliță RCA', icon:'🛡️', ocr:true},
  {key:'polita_casco', label:'Poliță CASCO', icon:'🚗', ocr:true},
  {key:'dovada_itp', label:'Dovadă ITP', icon:'🔍', ocr:true},
  {key:'dovada_rovinieta', label:'Dovadă Rovinieta', icon:'🛣️', ocr:true},
  {key:'poza_km', label:'Poză kilometraj bord', icon:'📷', ocr:true},
  {key:'certificat_transport', label:'Certificat transport marfă', icon:'🚛', ocr:true},
  {key:'licenta_traseu', label:'Licență traseu', icon:'📜', ocr:true},
  {key:'certificat_adr', label:'Certificat ADR (mărfuri periculoase)', icon:'⚠️', ocr:true},
  {key:'autorizatie_speciala', label:'Autorizație specială', icon:'📋', ocr:true},
  {key:'asigurare_cmr', label:'Asigurare CMR', icon:'🛡️', ocr:true},
  {key:'tahograf', label:'Card tahograf / Certificat tahograf', icon:'⏱️', ocr:true},
];

const CUSTOM_DOC_KEYS = ['certificat_transport','licenta_traseu','certificat_adr','autorizatie_speciala','asigurare_cmr','tahograf'];

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

function getOcrSummary(data, docType) {
  if (!data) return '';
  const d = typeof data === 'string' ? JSON.parse(data) : data;
  if (docType === 'talon') return `${d.brand || ''} ${d.model || ''} ${d.year || ''} · ${d.plate_number || ''}`.trim();
  if (docType === 'polita_rca') {
    const parts = [];
    if (d.denumire_asigurat) parts.push(`Asigurat: ${d.denumire_asigurat}`);
    if (d.data_expirare) parts.push(`Expiră: ${d.data_expirare}`);
    if (d.numar_polita) parts.push(`Poliță: ${d.numar_polita}`);
    return parts.join(' | ');
  }
  if (docType === 'polita_casco') {
    const parts = [];
    if (d.denumire_asigurat) parts.push(`Asigurat: ${d.denumire_asigurat}`);
    if (d.data_expirare) parts.push(`Expiră: ${d.data_expirare}`);
    if (d.numar_polita) parts.push(`Poliță: ${d.numar_polita}`);
    return parts.join(' | ');
  }
  if (docType === 'dovada_itp') {
    const parts = [];
    if (d.data_expirare) parts.push(`Expiră: ${d.data_expirare}`);
    if (d.rezultat_itp) parts.push(`Rezultat: ${d.rezultat_itp}`);
    return parts.join(' | ');
  }
  if (docType === 'dovada_rovinieta') {
    return d.data_expirare ? `Expiră: ${d.data_expirare}` : '';
  }
  if (docType === 'poza_km') return d.current_km ? `Kilometraj: ${d.current_km} km` : '';
  // custom types: show data_expirare if available
  if (d.data_expirare) return `Expiră: ${d.data_expirare}`;
  return '';
}

function CustomExpiryModal({ vehicleId, docType, docLabel, prefillDate, onClose, onSaved }) {
  const [date, setDate] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    // Convert DD.MM.YYYY → YYYY-MM-DD for input[type=date]
    if (prefillDate) {
      const m = prefillDate.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (m) setDate(`${m[3]}-${m[2].padStart(2,'0')}-${m[1].padStart(2,'0')}`);
      else setDate(prefillDate);
    }
  }, [prefillDate]);

  const save = async () => {
    if (!date) { setErr('Selectează data expirării.'); return; }
    setSaving(true);
    try {
      const data = await api('/expiry/custom', {
        method: 'POST',
        body: JSON.stringify({ vehicle_id: vehicleId, doc_type: docType, label: docLabel, expiry_date: date })
      });
      if (data.expiry) { onSaved(); onClose(); }
      else setErr(data.error || 'Eroare la salvare.');
    } catch { setErr('Eroare conexiune.'); }
    setSaving(false);
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'14px',width:'100%',maxWidth:'380px',overflow:'hidden'}}>
        <div style={{background:NAVY,padding:'14px 18px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{color:'#fff',fontWeight:800,fontSize:'14px'}}>📅 Adaugă la expirări</div>
          <button onClick={onClose} style={{background:'rgba(255,255,255,.15)',border:'none',borderRadius:'7px',padding:'5px 10px',color:'#fff',cursor:'pointer',fontSize:'14px'}}>✕</button>
        </div>
        <div style={{padding:'18px'}}>
          <div style={{marginBottom:'12px'}}>
            <div style={{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px'}}>Tip document</div>
            <div style={{background:'#F4F4F4',borderRadius:'8px',padding:'9px 12px',fontSize:'13px',fontWeight:600,color:DARK}}>{docLabel}</div>
          </div>
          <div style={{marginBottom:'14px'}}>
            <div style={{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px'}}>Data expirării *</div>
            <input type="date" value={date} onChange={e=>setDate(e.target.value)}
              style={{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'}}/>
          </div>
          {err && <div style={{background:'#FEE2E2',borderRadius:'8px',padding:'8px 12px',fontSize:'12px',color:'#B91C1C',marginBottom:'12px'}}>{err}</div>}
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={save} disabled={saving}
              style={{...s.btn,background:GOLD,color:DARK,flex:1,opacity:saving?0.7:1}}>
              {saving ? 'Se salvează...' : '💾 Salvează'}
            </button>
            <button onClick={onClose} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555'}}>Anulează</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function DocumentsUpload({ vehicleId, onDataExtracted, onCustomExpirySaved }) {
  const [documents, setDocuments] = useState([]);
  const [uploading, setUploading] = useState(null);
  const [extracting, setExtracting] = useState(null);
  const [msg, setMsg] = useState('');
  const [ocrResults, setOcrResults] = useState({});
  const [customExpiryModal, setCustomExpiryModal] = useState(null); // { docType, docLabel, prefillDate }

  useEffect(() => { loadDocuments(); }, [vehicleId]);

  const loadDocuments = async () => {
    const data = await api(`/documents/vehicle/${vehicleId}`);
    if (data.documents) setDocuments(data.documents);
  };

  const uploadFile = async (file, docType) => {
    setUploading(docType);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('vehicle_id', vehicleId);
    formData.append('doc_type', docType);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/documents/upload', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: formData
      });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch(e) { setMsg('Eroare server: ' + text.substring(0,100)); setUploading(null); return; }
      if (data.document) {
        setMsg('✓ Document încărcat! Apasă "🤖 OCR" pentru a extrage datele automat.');
        loadDocuments();
      } else { setMsg(data.error || 'Eroare la upload'); }
    } catch(err) { setMsg('Eroare conexiune: ' + err.message); }
    setUploading(null);
    setTimeout(() => setMsg(''), 6000);
  };

  const runOCR = async (documentId, docType) => {
    setExtracting(documentId);
    setMsg('🤖 Se extrag datele prin AI... (10-20 secunde)');
    try {
      const data = await api('/ocr/extract', {
        method: 'POST',
        body: JSON.stringify({ document_id: documentId, vehicle_id: vehicleId })
      });
      if (data.success) {
        setOcrResults(prev => ({ ...prev, [documentId]: data.data }));
        const summary = getOcrSummary(data.data, docType);
        setMsg('✓ Date extrase cu succes prin OCR AI!' + (summary ? ' · ' + summary : ''));
        if (onDataExtracted) onDataExtracted(data.data, docType);
        loadDocuments();
      } else {
        setMsg('✗ OCR eșuat: ' + (data.error || 'Eroare necunoscută'));
      }
    } catch { setMsg('✗ Eroare conexiune OCR'); }
    setExtracting(null);
    setTimeout(() => setMsg(''), 8000);
  };

  const deleteDoc = async (id) => {
    if (!window.confirm('Ștergi acest document?')) return;
    const token = localStorage.getItem('token');
    await fetch(`/api/documents/${id}`, {
      method: 'DELETE',
      headers: { Authorization: 'Bearer ' + token }
    });
    setMsg('✓ Document șters.');
    loadDocuments();
    setTimeout(() => setMsg(''), 3000);
  };

  return (
    <div>
      {customExpiryModal && (
        <CustomExpiryModal
          vehicleId={vehicleId}
          docType={customExpiryModal.docType}
          docLabel={customExpiryModal.docLabel}
          prefillDate={customExpiryModal.prefillDate}
          onClose={() => setCustomExpiryModal(null)}
          onSaved={() => { setMsg('✓ Expirare adăugată în tab-ul Expirări!'); setTimeout(()=>setMsg(''),4000); if (onCustomExpirySaved) onCustomExpirySaved(); }}
        />
      )}

      {msg && (
        <div style={{background:msg.includes('✓')?'#DCFCE7':msg.includes('🤖')?'#EDE9FE':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':msg.includes('🤖')?PURPLE:'#B91C1C',marginBottom:'12px',fontWeight:500}}>
          {msg}
        </div>
      )}

      <div style={{display:'flex',flexDirection:'column',gap:'7px'}}>
        {DOC_TYPES.map(dt => {
          const uploaded = documents.filter(d => d.doc_type === dt.key);
          const isUploading = uploading === dt.key;
          const doc = uploaded[0];
          const isExtracting = doc && extracting === doc.id;
          const ocrDone = doc && (doc.ocr_status === 'done' || ocrResults[doc?.id]);
          const rawOcrData = ocrResults[doc?.id] || doc?.ocr_data;
          const ocrData = rawOcrData ? (typeof rawOcrData === 'string' ? JSON.parse(rawOcrData) : rawOcrData) : null;
          const summary = ocrDone && ocrData ? getOcrSummary(ocrData, dt.key) : '';
          const isCustomType = CUSTOM_DOC_KEYS.includes(dt.key);
          const hasCustomExpiry = isCustomType && ocrData && ocrData.data_expirare;

          return (
            <div key={dt.key} style={{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'10px',padding:'12px 15px'}}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                  <div style={{width:'36px',height:'36px',borderRadius:'8px',background:uploaded.length>0?'#DCFCE7':'#F4F4F4',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',flexShrink:0}}>{dt.icon}</div>
                  <div>
                    <div style={{fontWeight:600,fontSize:'13px'}}>{dt.label}</div>
                    {uploaded.length > 0 ? (
                      <div style={{fontSize:'10px',marginTop:'2px'}}>
                        <span style={{color:'#15803D'}}>✓ {doc.original_filename} · {new Date(doc.uploaded_at).toLocaleDateString('ro-RO')}</span>
                        {ocrDone && <span style={{color:PURPLE,marginLeft:'6px'}}>· 🤖 OCR ✓</span>}
                      </div>
                    ) : (
                      <div style={{fontSize:'10px',color:'#888',marginTop:'2px'}}>Neîncărcat</div>
                    )}
                    {/* OCR summary inline */}
                    {summary && (
                      <div style={{fontSize:'10px',color:'#15803D',fontWeight:600,marginTop:'3px'}}>{summary}</div>
                    )}
                  </div>
                </div>

                <div style={{display:'flex',gap:'6px',alignItems:'center',flexShrink:0,flexWrap:'wrap',justifyContent:'flex-end'}}>
                  {uploaded.length > 0 ? (
                    <>
                      {dt.ocr && !ocrDone && (
                        <button onClick={()=>runOCR(doc.id, dt.key)} disabled={!!extracting}
                          style={{...s.btn,background:isExtracting?'#EDE9FE':PURPLE,color:'#fff',padding:'5px 12px',fontSize:'11px'}}>
                          {isExtracting ? '⏳ AI...' : '🤖 OCR'}
                        </button>
                      )}
                      {ocrDone && (
                        <span style={{background:'#EDE9FE',color:PURPLE,fontSize:'10px',fontWeight:700,padding:'3px 8px',borderRadius:'7px'}}>🤖 ✓</span>
                      )}
                      {/* Buton "Adaugă la expirări" pentru doc-uri custom cu data OCR */}
                      {hasCustomExpiry && (
                        <button
                          onClick={() => setCustomExpiryModal({ docType: dt.key, docLabel: dt.label, prefillDate: ocrData.data_expirare })}
                          style={{...s.btn,background:'#DCFCE7',color:'#15803D',padding:'5px 12px',fontSize:'11px',border:'0.5px solid #22C55E'}}>
                          📅 Expirări
                        </button>
                      )}
                      <a href={doc.s3_key} target="_blank" rel="noreferrer"
                        style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'5px 12px',fontSize:'11px',textDecoration:'none'}}>
                        👁 Vezi
                      </a>
                      <button onClick={()=>deleteDoc(doc.id)}
                        style={{...s.btn,background:'#FEE2E2',color:RED,padding:'5px 12px',fontSize:'11px'}}>
                        🗑
                      </button>
                    </>
                  ) : (
                    <label style={{...s.btn,background:GOLD,color:DARK,padding:'5px 14px',fontSize:'11px',cursor:'pointer',display:'inline-block'}}>
                      {isUploading ? '⏳...' : '+ Încarcă'}
                      <input type="file" style={{display:'none'}} accept=".jpg,.jpeg,.png,.pdf,.heic,.webp"
                        onChange={e=>{ if(e.target.files[0]) uploadFile(e.target.files[0], dt.key); e.target.value=''; }}
                        disabled={!!uploading}/>
                    </label>
                  )}
                </div>
              </div>

              {/* OCR Results expanded */}
              {ocrDone && ocrData && (
                <div style={{marginTop:'10px',background:'#F5F3FF',borderRadius:'8px',padding:'10px',fontSize:'11px'}}>
                  <div style={{color:PURPLE,fontWeight:700,marginBottom:'6px'}}>🤖 Date extrase automat:</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                    {Object.entries(ocrData)
                      .filter(([k,v]) => v && v !== 'null' && v !== '')
                      .map(([k,v]) => (
                        <div key={k} style={{background:'#fff',border:'0.5px solid #DDD6FE',borderRadius:'6px',padding:'3px 8px'}}>
                          <span style={{color:'#888',fontSize:'10px'}}>{k}: </span>
                          <span style={{fontWeight:600,color:DARK}}>{String(v)}</span>
                        </div>
                      ))
                    }
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
